<template>
    <div class='list' :class='{ "state-loading": loading }' v-show='ready'>

        <filters class='list__filters'
                 :filters='filters'
                 :selectedIndustry='selectedIndustry'
                 :selectedYear='selectedYear'
                 :selectedRegion='selectedRegion'
                 :allText='transAllText'
                 :industryText='transIndustryText'
                 :globalText='transGlobalText'
                 v-if='ready' />

        <banner class='list__banner'
                :url='banner.url'
                :title='banner.cta_title'
                :dek='banner.cta_dek'
                :bg_color='banner.cta_bg_color'
                :text_color='banner.cta_text_color'
                :cta_bg_color='banner.cta_link_bg_color'
                :cta_text='transBannerCtaText'
                v-if='banner' />

        <div class='list__results alt-bgs' v-if='results.length > 0'>
            <result :result='result' v-for='result in results' :key='result.slug' />
        </div>

        <div class='list__results list__results--empty vertical--1' v-else-if='ready'>
            <div class='container'>
                <div class='row offset--md-3'>
                    <b>{{ transNoResultsText }}</b>
                </div>
            </div>
        </div>

        <transition name='fade'>
            <div v-if='loading'>
                <div class='spinner'>
                    <span class='show-for-sr'>Loading...</span>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
import $ from 'jquery';
import shuffle from 'lodash/shuffle';
import api from '~/js/thelist/api';
import Filters from '~/js/thelist/components/Filters.vue';
import Result from '~/js/thelist/components/Result.vue';
import Banner from '~/js/thelist/components/Banner.vue';

export default {
    created () {
        api.get(data => {
            this.filters = {
                years: data.years,
                regions: data.regions,
                industries: data.industries
            };
            this.selectedRegion = data.selected_region;
            this.selectedYear = data.selected_year;
            this.selectedIndustry = data.selected_industry;
            this.results = shuffle(data.winners);
            this.banner = data.region_banner;
            this.loading = false;
            this.ready = true;
        }, this.$route.path);
    },

    data () {
        const $e = $(this.$root.$el);

        return {
            ready: false,
            loading: true,
            selectedIndustry: null,
            selectedYear: null,
            selectedRegion: null,
            filters: {
                years: null,
                regions: null,
                industries: null
            },
            results: [],
            banner: false,
            // il8n
            transNoResultsText: $e.data('trans-no-results'),
            transBannerCtaText: $e.data('trans-go-to-region'),
            transAllText: $e.data('trans-all'),
            transIndustryText: $e.data('trans-industry'),
            transGlobalText: $e.data('trans-global')
        }
    },

    watch: {
        selectedYear () {
            // change the selected year in the hero (outside the app)
            const $heroYear = $('#hero-year');

            if ($heroYear.length > 0) {
                $heroYear.text(this.selectedYear);
            }
        }
    },

    beforeRouteUpdate (to, from, next) {
        this.loading = true;

        api.get(data => {
            this.selectedRegion = data.selected_region;
            this.selectedYear = data.selected_year;
            this.selectedIndustry = data.selected_industry;
            this.results = shuffle(data.winners);
            this.banner = data.region_banner;
            this.loading = false;
            next();
        }, to.path);
    },

    components: {
        Filters,
        Result,
        Banner
    }
}
</script>



// WEBPACK FOOTER //
// assets/js/thelist/components/List.vue